export default () => {
  const array = new Uint32Array(8)
  window.crypto.getRandomValues(array)
  return parseInt(array.reduce((acc, val) => acc.concat(val.toString()), ''), 10)
}

